import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { makeSelectAmostraByItemId } from '@store/selectors/amostrasSelector';

export const AmostraCounter = ({ idSolicitacaoProcessoItem }) => {
  const selectAmostra = useMemo(
    () => makeSelectAmostraByItemId(idSolicitacaoProcessoItem),
    [idSolicitacaoProcessoItem]
  );

  const amostra = useSelector(selectAmostra);

  const total = amostra?.quantidadeTotal || 0;

  return <span className="small">{total}</span>;
};
